import React, { useMemo } from "react";
import { withRouter } from "react-router-dom";
import ReactQuill from "react-quill";

const MyEditor = ({ setEditor, editor }) => {
  const modules = useMemo(
    () => ({
      toolbar: [
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ["bold", "italic", "underline", "strike", "blockquote"],
        [{ size: [] }],
        [{ font: [] }],
        [{ align: ["right", "center", "justify"] }],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link", "image"],
        [{ color: [] }],
        [{ background: [] }],
      ],
    }),
    []
  );

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "link",
    "color",
    "image",
    "background",
    "align",
    "size",
    "font",
  ];

  return (
    <>
      {editor && (
        <ReactQuill
          theme="snow"
          modules={modules}
          formats={formats}
          value={editor}
          onChange={(value) => setEditor(value)}
        />
      )}
    </>
  );
};

export default withRouter(MyEditor);
